import { useEffect } from 'react'
import { connect } from 'react-redux'
import AccountSection from './account-section/index.jsx'
import CommunicationPreferencesSection from './communication-preferences-section/index.jsx'
import HelpPoliciesSection from './help-policies-section/index.jsx'
import SecuritySection from './security-section/index.jsx'
import { profileDataSelector } from '../../../../shared/app/bundles/user/index.js'
import ContentCrateLoading from '../../../../shared/app/components/content-crate-loading/index.jsx'
import LegacyPaddedContentColumn from '../../../../shared/app/components/legacy-padded-content-column/index.jsx'
import { trackSettingsView } from '../../state/track-event.js'
import { localeSupportsMfaSelector } from '../../state/selectors.js'
import AccountDeleteButton from './account-delete/account-delete-button.jsx'

const enableMfaFeatures = true

const Settings = ({ user, localeSupportsMfa }) => {
  useEffect(() => {
    trackSettingsView()
  }, [])

  if (!user) {
    return (
      <div className="py9">
        <ContentCrateLoading />
      </div>
    )
  }

  return (
    <LegacyPaddedContentColumn size="sm">
      <AccountSection />
      <CommunicationPreferencesSection />
      {enableMfaFeatures && localeSupportsMfa && <SecuritySection />}
      <HelpPoliciesSection />
      <AccountDeleteButton />
    </LegacyPaddedContentColumn>
  )
}

const select = (state) => ({
  user: profileDataSelector(state),
  localeSupportsMfa: localeSupportsMfaSelector(state),
})

export default connect(select)(Settings)
